// Keep the original bucket width when hiding future samples, so past values
// retain their time labels and the current partial bucket ends at the cutoff.
export function chartTimeWindow(range, bucketCount, now = Date.now()) {
  const fromMs = Date.parse(range?.from);
  const endMs = Date.parse(range?.to);
  if (!Number.isFinite(fromMs) || !Number.isFinite(endMs)
      || endMs <= fromMs || bucketCount <= 0) return null;
  const bucketMs = (endMs - fromMs) / bucketCount;
  const toMs = Math.min(endMs, now);
  return {
    bucketMs,
    fromMs,
    toMs,
    visibleCount: Math.max(0, Math.min(bucketCount, Math.ceil((toMs - fromMs) / bucketMs))),
  };
}
